import { http } from "./http";

/**
 * Fetch transfers for a single adult.
 *
 * Assumes backend supports:
 *   GET /api/adult-transfers/{adultId}
 *
 * If your GET path differs, tweak it here (single place).
 */
export async function listAdultTransfers(adultId) {
  if (!adultId) return [];
  return (await http.request(`api/adult-transfers/${adultId}`)) || [];
}
